import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

function BreadCrumbs({ items }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className='d-flex '>
            <Button
                onClick={() => navigate(-1)}
                className='border-0 bg-transparent d-flex'
            >
                <FontAwesomeIcon style={{color:"#df4c4e",fontSize:"24px"}} icon={faChevronLeft} />
            </Button>
            <Breadcrumb className='d-flex align-items-center'>
                {items.map((item, index) => {
                    // Labels carrying user data (a class/group/ticket title) must not
                    // go through t() — a title that collides with a translation key
                    // would render the wrong text, or an i18next error if that key
                    // resolves to an object. Opt out with translate: false.
                    const label = item.translate === false ? item.label : t(item.label);
                    return item.active ? (
                        <Breadcrumb.Item key={index} active>
                            {label}
                        </Breadcrumb.Item>
                    ) : (
                        <Breadcrumb.Item key={index}>
                            <Link to={item.href}>
                                {label}
                            </Link>
                        </Breadcrumb.Item>
                    );
                })}
            </Breadcrumb>
        </div>
    );
}

export default BreadCrumbs;
